import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  networkOverviewSchema,
  platformOverviewSchema,
  type NetworkOverview,
  type PlatformOverview,
} from '@netdeck/contracts';
import { apiRequest } from '../../shared/api/client';

export const networkOverviewKey = ['overview', 'network'] as const;
export const platformOverviewKey = ['overview', 'platform'] as const;

/**
 * Обзор сети. Обновляется раз в полминуты: доступность за сутки не меняется
 * заметно быстрее, а лента событий и счётчики узлов приходят живьём
 * по WebSocket на других экранах — здесь нужна сводка, а не поток.
 */
export function useNetworkOverview(enabled: boolean): UseQueryResult<NetworkOverview, Error> {
  return useQuery({
    queryKey: networkOverviewKey,
    queryFn: () => apiRequest('/overview/network', networkOverviewSchema),
    enabled,
    refetchInterval: 30_000,
  });
}

/**
 * Обзор платформы. Обновляется чаще сети — раз в десять секунд.
 *
 * Причина в критерии приёмки: потерявший связь агент обязан быть виден
 * на обзоре не позже минуты после обрыва. Сервер узнаёт об обрыве сразу
 * (закрытый сокет) или через 35 секунд (пропущенные heartbeat), и десяти
 * секунд опроса поверх этого хватает с запасом.
 */
export function usePlatformOverview(enabled: boolean): UseQueryResult<PlatformOverview, Error> {
  return useQuery({
    queryKey: platformOverviewKey,
    queryFn: () => apiRequest('/overview/platform', platformOverviewSchema),
    enabled,
    refetchInterval: 10_000,
  });
}
